export default  {
    '申请人': '申请人',
    "邮箱": "邮箱",
    "其他联系方式": "其他联系方式",
    "profile_long": "账号（Decathlon Profile, like: EXU22）",
    "用途": "用途",
    "账号": "账号",
    "工厂": "工厂",
    "迪卡侬用户": "迪卡侬用户",
    "外部用户": "外部用户",
    "取消": "取消",
    "发送": "发送",
    "公司名称": "公司名称",
    "外部用户": "外部用户",
    "外部用户登录": "外部用户登录",
    "忘记密码": "忘记密码",
    "没有账号": "没有账号",
    "提醒": "提醒",
    "此密码已使用超过三个月，请前去修改密码方可使用": "此密码已使用超过三个月，请前去修改密码方可使用",
    "修改密码": "修改密码",
    "修改成功": "修改成功",
    "你已成功修改密码，请重新登录": "你已成功修改密码，请重新登录",
    "关闭": "关闭",
    "你的账号没有维护邮箱，为保证账号安全，请去维护": "你的账号没有维护邮箱，为保证账号安全，请去维护",
    "维护邮箱": "维护邮箱",
    "邮箱": "邮箱",
    "获取验证码": "获取验证码",
    "验证码": "验证码",
    "输入新密码": "输入新密码",
    "重新输入新密码": "重新输入新密码",
    "我的组织": "我的组织",
    "数据权限": "数据权限",
    "自己组织": "自己组织",
    "指定组织": "指定组织",
    "全部组织": "全部组织",
    "个人信息": "个人信息",
    "我的密码": "我的密码",
    "组织与权限": "组织与权限",
    "退出登录": "退出登录",
    "我的数据组": "我的数据组",
    "我的权限": "我的权限",
    "新增": "新增",
    "新增token": "新增token",
    "Token名称": "Token名称",
    "密码规则": "密码规则",
    "密码长度8-16位": "密码长度8-16位",
    "须同时包含数字，字母，特殊字符中的任意两种": "须同时包含数字，字母，特殊字符中的任意两种",
    "保存": "保存",
    "旧密码": "旧密码",
    "重新输入新密码": "重新输入新密码",
    "新密码": "新密码",
    "我的邮箱": "我的邮箱",
    "邮箱地址": "邮箱地址",
    "操作": "操作",
    "请立即维护您的邮箱": "请立即维护您的邮箱",
    "更换邮箱": "更换邮箱",
    "绑定邮箱": "绑定邮箱",
    "我的微信": "我的微信",
    "微信昵称": "微信昵称",
    "请绑定微信": "请绑定微信",
    "解除绑定微信": "解除绑定微信",
    "绑定微信": "绑定微信",
    "更换邮箱验证": "更换邮箱验证",
    "是否解除绑定微信": "是否解除绑定微信",
    "确认解绑": "确认解绑",
    "确定": "确定",
    "去申请": "去申请",
    "登录": "登录",
    "用户名": "用户名",
    "密码": "密码",
    "用户名不能为空": "用户名不能为空",
    "密码不能为空": "密码不能为空",
    "账号不能为空": "账号不能为空",
    "验证码不能为空": "验证码不能为空",
    "邮箱不能为空": "邮箱不能为空",
    "邮箱格式不正确": "邮箱格式不正确",
    "两次密码不一致": "两次密码不一致",
    "重新获取(": "重新获取(",
    "密码长度不能小于8位": "密码长度不能小于8位",
    "密码长度不能大于16位": "密码长度不能大于16位",
    "申请人不能为空": "申请人不能为空",
    "用途不能为空": "用途不能为空",
    "公司名称不能为空": "公司名称不能为空",
    "请按规则填写": "请按规则填写",
    "修改成功": "修改成功",
    "修改失败": "修改失败",
    "请填写旧密码": "请填写旧密码",
    "微信绑定成功": "微信绑定成功",
    "解除绑定成功": "解除绑定成功",
    "保存成功": "保存成功",
    "邮箱和账号不能为空": "邮箱和账号不能为空",
    "成衣厂": "成衣厂",
    "面料厂": "面料厂",
    "国家": "国家",
    "DPP": "DPP",
    "角色": "角色",
    "国家不能为空": "国家不能为空",
    "DPP不能为空": "DPP不能为空",
    "角色不能为空": "角色不能为空",
    "请选择国家": "请选择国家",
    "请选择DPP": "请选择DPP",
    "请选择角色": "请选择角色",
    "我们应该怎么称呼您": "我们应该怎么称呼您",
    "邮件地址": "邮件地址",
    "手机号（选填）": "手机号（选填）",
    "请输入账号": "请输入账号",
    "请描述": "请描述",
    "请输入工厂名称": "请输入工厂名称",
    "登录失败": "登录失败",
    "秒后跳转到登录页面,如未自动跳转请点击": "秒后跳转到登录页面,如未自动跳转请点击",
    "该用户没有获得审批,请申请账号": "该用户没有获得审批,请申请账号",
    "查询用户信息失败": "查询用户信息失败",
    "用户被禁止访问": "用户被禁止访问",
}



// WEBPACK FOOTER //
// ./src/language/zh-CN.js